<script setup lang="ts">
import type { NuxtError } from '#app'
import { useI18n } from 'vue-i18n'
const { t: $t } = useI18n()

const props = defineProps({
    error: Object as () => NuxtError
})

const title = props.error.statusCode === 404 ? '404 Not Found' : 'An error occurred'
useHead({
    title
})

const goBack = () => {
    window.history.go(-1)
}
</script>
<template>
    <div class="error-container">
        <v-icon x-large color="#ddd">mdi-robot-dead</v-icon>
        <h2>{{ error.statusCode }}</h2>
        <h4 v-if="error.statusCode !== 404" @click="goBack">
            {{ $t('oopsSomethingWentWrongClickToGoBack') }}
        </h4>
        <h4 v-else @click="goBack">
            {{ $t('oopsPageNotFoundClickToGoBack') }}
        </h4>
    </div>
</template>
<style scoped>
.error-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #656464;
}
h2 {
    color: #ffffff;
    font-size: 20vh;
    line-height: 20vh;
}
h4 {
    color: #ffffff;
    font-size: 5vh;
    line-height: 5vh;
    cursor: pointer;
}
</style>
